import antDesign from "../assets/antd.webp";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

export function Skills() {
  const { t } = useTranslation()
  const items = [
    { img: "https://img.icons8.com/?size=100&id=20909&format=png&color=000000", name: (t("skills.html")) },
    { img: "https://img.icons8.com/?size=100&id=7gdY5qNXaKC0&format=png&color=000000", name: (t('skills.css3')) },
    { img: "https://img.icons8.com/?size=100&id=108784&format=png&color=000000", name: (t('skills.javaScript')) },
    { img: "https://img.icons8.com/?size=100&id=uJM6fQYqDaZK&format=png&color=000000", name: (t('skills.typeScript')) },
    { img: "https://img.icons8.com/?size=100&id=123603&format=png&color=000000", name: (t('skills.reactJs')) },
    { img: "https://img.icons8.com/?size=100&id=3tC9EQumUAuq&format=png&color=000000", name: (t('skills.github')) },
    { img: "https://img.icons8.com/?size=100&id=rY6agKizO9eb&format=png&color=000000", name: (t('skills.vueJs')) },
    { img: "https://img.icons8.com/?size=100&id=jD-fJzVguBmw&format=png&color=000000", name: (t('skills.redux')) },
    { img: "https://img.icons8.com/?size=100&id=r2OarXWQc7B6&format=png&color=000000", name: (t('skills.nextJs')) },
    { img: "https://img.icons8.com/?size=100&id=123603&format=png&color=000000", name: (t('skills.reactNative')) },
    { img: "https://img.icons8.com/?size=100&id=rHpveptSuwDz&format=png&color=000000", name: t('skills.jwt') },
    { img: "https://img.icons8.com/?size=100&id=g9mmSxx3SwAI&format=png&color=000000", name: t('skills.bootstrap') },
    { img: "https://img.icons8.com/?size=100&id=gFw7X5Tbl3ss&format=png&color=000000", name: t('skills.mui') },
    { img: "https://img.icons8.com/?size=100&id=x7XMNGh2vdqA&format=png&color=000000", name: t('skills.tailwindCss') },
    { img: antDesign, name: t('skills.antDesign') },
    { img: "https://img.icons8.com/?size=100&id=54087&format=png&color=000000", name: t('skills.nodeJs') },
    { img: "https://img.icons8.com/?size=100&id=2ZOaTclOqD4q&format=png&color=000000", name: t('skills.expressJs') },
    { img: "https://img.icons8.com/?size=100&id=9ESZMOeUioJS&format=png&color=000000", name: t('skills.nestJs') },
    { img: "https://img.icons8.com/?size=100&id=UGYn5TapNioV&format=png&color=000000", name: t('skills.php') },
    { img: "https://img.icons8.com/?size=100&id=hUvxmdu7Rloj&format=png&color=000000", name: t('skills.laravel') },
    { img: "https://img.icons8.com/?size=100&id=13441&format=png&color=000000", name: t('skills.python') },
    { img: "https://img.icons8.com/?size=100&id=114322&format=png&color=000000", name: t('skills.ai') },
    { img: "https://img.icons8.com/?size=100&id=IM1zmzuzvwiu&format=png&color=000000", name: t('skills.ml') },
    { img: "https://img.icons8.com/?size=100&id=zdI5E8moxhs-&format=png&color=000000", name: t('skills.graphql') },
    { img: "https://img.icons8.com/?size=100&id=bosfpvRzNOG8&format=png&color=000000", name: t('skills.mongoDb') },
    { img: "https://img.icons8.com/?size=100&id=11572&format=png&color=000000", name: t('skills.mysql') },
    { img: "https://img.icons8.com/?size=100&id=38561&format=png&color=000000", name: t('skills.postgress') },
    { img: "https://img.icons8.com/?size=100&id=62452&format=png&color=000000", name: t('skills.firebase') },
    { img: "https://img.icons8.com/?size=100&id=pHS3eRpynIRQ&format=png&color=000000", name: t('skills.redis') },
    { img: "https://img.icons8.com/?size=100&id=33039&format=png&color=000000", name: t('skills.aws') },
    { img: "https://img.icons8.com/?size=100&id=oROcPah5ues6&format=png&color=000000", name: t('skills.jira') },
    { img: "https://img.icons8.com/?size=100&id=i0Rib28TKAL1&format=png&color=000000", name: t('skills.messageBot') },
  ];

  const [screenConfig, setScreenConfig] = useState(() => getScreenConfig());

  function getScreenConfig() {
    const width = window.innerWidth;
    if (width < 768) {
      return { numRows: 12, circlesPerRow: [3, 2] };
    } else if (width >= 768 && width < 1024) {
      return { numRows: 7, circlesPerRow: [5, 4] };
    } else if (width >= 1024 && width < 1800)
      return { numRows: 5, circlesPerRow: [7, 6] }
    else {
      return { numRows: 3, circlesPerRow: [11, 10] };
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setScreenConfig(getScreenConfig());
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { numRows, circlesPerRow } = screenConfig;
  let itemIndex = 0;

  const newRows = Array.from({ length: numRows }, (_, rowIndex) => {
    const circlesInRow = circlesPerRow[rowIndex % 2];

    return (
      <>
        <div className="flex space-x-4 md:space-x-10 lg:space-x-10" key={rowIndex}>
          {Array.from({ length: circlesInRow }).map((_, circleIndex) => {
            const item = items[itemIndex % items.length];
            itemIndex++;

            return (
              <div key={circleIndex} className="text-center justify-center py-2">
                <div className="skills-img w-24 h-24 p-4 rounded-full overflow-hidden mx-auto border-2 border-[#61cbf5]">
                  <img src={item?.img} alt={item?.name} className="w-full h-full object-cover" />
                </div>
                <p className="text-sm mt-2">{item?.name}</p>
              </div>
            );
          })}
        </div>
        <style>
          {`
                .skills-img {
                    transition: all 0.8s ease-in-out;
                }
                .skills-img:hover {
                    transform: scale(1.2); 
                }
                `}
        </style>
      </>
    );
  });

  return (
    <>
      <Helmet>
        <meta name="description" content={t("meta.description")} />
        <meta name="keywords" content={t("meta.keywords")} />
        <meta name="author" content={t("meta.author")} />
      </Helmet>
      <p className="text-3xl text-center font-bold py-12 lg:py-20 md:text-4xl lg:text-5xl">{t('skills.title')}</p>
      <div className="skills flex flex-col justify-center items-center">{newRows}</div>


    </>
  );
}
